import React, { Fragment } from 'react';
import '../loggedOut.css';

const CommunityOutdoorAccess = () => {
    return (
        <Fragment>
            <div className="logged-out community-outdoor-access-page">
                <section className="service-hero scene scene--hero page-hero">
                    <div className="container">
                        <div className="hero-grid">
                            <div className="hero-copy">
                                <h1 className="display-5 mb-4">Community Outdoor Access</h1>
                                <p className="lead">
                                    Beyond Community Access originally founded to provide a highly customised and tailored community access program - where we focused on accessing the outdoors, recreation and social programs. We have come a long way since then, but our community access and outdoors program remains a core focus.
                                </p>
                            </div>
                            <div className="hero-media">
                                <div className="image-shell image-shell--hero">
                                    <img
                                        src="/marketing_images/community_outdoor_access/header.jpg"
                                        alt="Community outdoor access activities"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="service-story scene scene--paper story-band">
                    <div className="container">
                        <div className="story-card">
                            <p className="mb-0">
                                Community Access with BCA is a highly customizable program, where each individual client has a support plan created collaboratively with the client, caregivers, allied health and the support worker. This ensures a positive engagement within the community, with measurable goals.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="service-activities scene scene--soft py-6">
                    <div className="container">
                        <div className="section-head">
                            <p className="mb-0">
                                Our clients enjoy a wide variety of activities including:
                            </p>
                        </div>

                        <div className="tile-grid">
                            {activities.map((activity) => (
                                <div className="tile-card" key={activity.title}>
                                    <div className="image-shell image-shell--card">
                                        <img
                                            src={activity.image}
                                            alt={activity.title}
                                            className="img-fluid"
                                        />
                                    </div>
                                    <p className="mb-0">{activity.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </Fragment>
    );

}

export default CommunityOutdoorAccess;

const activities = [
    { title: "Hiking", image: "/marketing_images/community_outdoor_access/hiking.png" },
    { title: "Fishing", image: "/marketing_images/community_outdoor_access/fishing.jpg" },
    { title: "Camping", image: "/marketing_images/community_outdoor_access/camping.jpg" },
    { title: "Swimming", image: "/marketing_images/community_outdoor_access/swimming.jpg" },
    { title: "Shopping", image: "/marketing_images/community_outdoor_access/shopping.jpg" },
    { title: "Socialisation", image: "/marketing_images/community_outdoor_access/socialisation.png" },
    { title: "Daily tasks", image: "/marketing_images/community_outdoor_access/daily_tasks.png" },
    { title: "Recreational activities", image: "/marketing_images/community_outdoor_access/recreational_activities.png" },
];
